import React, { useRef, useEffect, useState } from "react";

export default function SignaturePad({ onChange, height = 180, label = "Sign here" }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const w = canvas.parentElement.clientWidth;
    canvas.width = w * ratio;
    canvas.height = height * ratio;
    canvas.style.width = "100%";
    canvas.style.height = height + "px";
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0E5C3A";
  }, [height]);

  const getXY = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches?.[0];
    const cx = touch ? touch.clientX : e.clientX;
    const cy = touch ? touch.clientY : e.clientY;
    return { x: cx - rect.left, y: cy - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawingRef.current = true;
    setEmpty(false);
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getXY(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawingRef.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getXY(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const end = () => {
    if (!drawingRef.current) return;
    drawingRef.current = false;
    const dataUrl = canvasRef.current.toDataURL("image/png");
    onChange?.(dataUrl);
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setEmpty(true);
    onChange?.("");
  };

  return (
    <div data-testid="signature-pad">
      <div className="sig-canvas-wrapper relative" style={{ height }}>
        <canvas
          ref={canvasRef}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          className="w-full h-full"
          data-testid="signature-canvas"
        />
        {empty && (
          <div className="absolute inset-0 flex items-center justify-center text-[#5E7166]/50 pointer-events-none text-sm font-medium">
            {label}
          </div>
        )}
      </div>
      <div className="flex gap-2 mt-2">
        <button type="button" onClick={clear} className="btn-ghost text-sm" data-testid="signature-clear-btn">Clear</button>
        <span className="text-xs text-[#5E7166] self-center">Use mouse or touch to sign</span>
      </div>
    </div>
  );
}
